// Core polyfills
import "core-js/stable";
import "regenerator-runtime/runtime";

// Fetch polyfill
import "whatwg-fetch";

// URL polyfill
import "url-polyfill";

// Promise polyfill
import "promise-polyfill/src/polyfill";

// AbortController polyfill
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";

// TextEncoder/TextDecoder polyfill
import { TextEncoder, TextDecoder } from "text-encoding";

// IntersectionObserver polyfill
import "intersection-observer";

// ResizeObserver polyfill
import ResizeObserver from "resize-observer-polyfill";

// MutationObserver polyfill
import "mutation-observer";

// Add polyfills to window object
if (typeof window !== "undefined") {
  window.TextEncoder = TextEncoder;
  window.TextDecoder = TextDecoder;
  window.ResizeObserver = ResizeObserver;
}

// Ensure all modern features are available
if (!Object.entries) {
  Object.entries = function (obj: Record<string, unknown>): [string, unknown][] {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}

if (!Object.fromEntries) {
  Object.fromEntries = function (entries: [string, unknown][]): Record<string, unknown> {
    return entries.reduce((obj: Record<string, unknown>, [key, val]) => {
      obj[key] = val;
      return obj;
    }, {});
  };
}

// Add Array.prototype.includes if not available
if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement: unknown): boolean {
    return this.indexOf(searchElement) !== -1;
  };
}

// Add String.prototype.includes if not available
if (!String.prototype.includes) {
  String.prototype.includes = function (search: string, start?: number): boolean {
    "use strict";
    if (typeof start !== "number") {
      start = 0;
    }
    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}
